import * as React from 'react';
import { useState } from 'react';
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../../components/AppNavbar';
import Header from '../../components/Header';
import SideMenu from '../../components/SideMenu';
import AppTheme from '../../shared-theme/AppTheme';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Card } from '@mui/material';
import MyCurrentPlan from './MyCurrentPlan';
import Pricing from '../../components/Pricing';

export default function Payment(props: { disableCustomTheme?: boolean }) {
  const [value, setValue] = useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme: any) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            <Box sx={{ width: '100%' }}>
              <Card>
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                      <Tab label="Meu plano" value="1" sx={{ fontSize: '0.8rem' }} />
                      <Tab label="Pagamento" value="2" sx={{ fontSize: '0.8rem' }} />
                    </TabList>
                  </Box>
                  <TabPanel value="1">
                    <MyCurrentPlan />
                  </TabPanel>
                  <TabPanel value="2" sx={{ pl: 0, pr: 0 }}>
                    <Pricing isPaymentPage={true} />
                  </TabPanel>
                </TabContext>
              </Card>
            </Box>
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}